import { reduce } from "et3-type-guards";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Descriptions from "./descriptions";

const UserDescriptions = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const userID = getUserAdvancedStore().currentUserId.get();
  const data = getUserAdvancedStore().userData.get(userID);
  const descriptionID = reduce(() => data.descriptionID, -1);
  const description = reduce(() => data.description, "");
  const descriptionStatus = reduce(() => data.descriptionStatus, "");
  const descriptionLanguage = reduce(() => data.descriptionLanguage, "");
  const peerDescriptionID = reduce(() => data.peerDescriptionID, -1);
  const peerDescription = reduce(() => data.peerDescription, "");
  const peerDescriptionStatus = reduce(() => data.peerDescriptionStatus, "");
  const peerDescriptionLanguage = reduce(
    () => data.peerDescriptionLanguage,
    ""
  );
  const descriptionAlignment =
    getUserAdvancedStore().getDescriptionAlignment(descriptionLanguage);
  const peerDescriptionAlignment =
    getUserAdvancedStore().getDescriptionAlignment(peerDescriptionLanguage);

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={950}
      height={305}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Descriptions
        userID={userID}
        selfDescriptionId={descriptionID}
        selfDescriptionStatus={descriptionStatus}
        selfDescription={description}
        selfDescriptionAlignment={descriptionAlignment}
        peerDescriptionId={peerDescriptionID}
        peerDescriptionStatus={peerDescriptionStatus}
        peerDescription={peerDescription}
        peerDescriptionAlignment={peerDescriptionAlignment}
      />
    </ET3Div>
  );
});
export default UserDescriptions;
